/** The model that answers QuantisAI chat: Claude, the only one offered. */
export type SIModelId = 'claude';
export type SIModelOption = { id: SIModelId; label: string; available: boolean; default?: boolean; beta?: boolean };
export type SIModelPicker = { value: SIModelId; options: SIModelOption[] };
export const SI_DEFAULT_MODELS: SIModelOption[] = [
 { id: 'claude', label: 'Claude Opus 5.5', available: true, default: true },
];
/** Before /si/status arrives, Claude. A server that still lists Pluto (Beta)
 *  has it dropped; one with no list at all is judged by `configured`. */
export function siModelOptions(status: { configured?: boolean; models?: { id: string; label: string; available: boolean; default?: boolean; beta?: boolean }[] } | null): SIModelOption[] {
 if (!status) return SI_DEFAULT_MODELS;
 // A present list is authoritative even when every entry is unknown to this build.
 if (Array.isArray(status.models)) return status.models.filter((option): option is SIModelOption => option.id === 'claude');
 return [{ ...SI_DEFAULT_MODELS[0], available: status.configured === true }];
}
